// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserDuplicateUser_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V20H2V2L20 2V0H0ZM22 6H6V22H8.08296C8.55904 19.1623 11.027 17 14 17C16.973 17 19.441 19.1623 19.917 22H22V6ZM17.874 22C17.4299 20.2748 15.8638 19 14 19C12.1362 19 10.5701 20.2748 10.126 22H17.874ZM4 4V24H24V4H4ZM14 14C15.1046 14 16 13.1046 16 12C16 10.8954 15.1046 10 14 10C12.8954 10 12 10.8954 12 12C12 13.1046 12.8954 14 14 14ZM14 16C16.2091 16 18 14.2091 18 12C18 9.79086 16.2091 8 14 8C11.7909 8 10 9.79086 10 12C10 14.2091 11.7909 16 14 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserDuplicateUser is a generated icon component.
 */
let IconUserUserDuplicateUser = IconUserUserDuplicateUser_1 = class IconUserUserDuplicateUser extends IconBaseElement {
    render() {
        return html `${IconUserUserDuplicateUser_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserDuplicateUser.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserDuplicateUser = IconUserUserDuplicateUser_1 = __decorate([
    customElement('zui-icon-user-user-duplicate-user')
], IconUserUserDuplicateUser);
export { IconUserUserDuplicateUser };
